"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const NativeSelect_1 = __importDefault(require("../../../common/js/atoms/NativeSelect"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../../common/js/helper/translation");
const ReturnStore_1 = __importDefault(require("../../stores/ReturnStore"));
const ReturnReasonObservableComponent = ({ returnObject }) => {
    const [selectedReasons, setSelectedReasons] = (0, react_1.useState)({});
    return (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.RESELLER_READ, AuthorizationScopes_1.default.RETURN_REASON_UPDATE], fallback: react_1.default.createElement(react_1.default.Fragment, null, (0, translation_1.t)('myassets.returns.table.select_return_reason', {
            returnReason: returnObject.returnReason,
        })) }, !returnObject.isInReturnProcess ? (react_1.default.createElement("div", null,
        react_1.default.createElement(NativeSelect_1.default, { className: (0, classnames_1.default)('znd-registration-company-information__country-select', {
                'znd-return-table-sub-item__error': ReturnStore_1.default.getValidationError(returnObject.id, 'returnReason'),
            }), value: selectedReasons[returnObject.id] || '', options: ReturnStore_1.default.getReturnReasonOptions(), placeholder: (0, translation_1.t)('myassets.returns.table.select_return_reason', {
                returnReason: returnObject.returnReason,
            }), onChange: (value) => {
                setSelectedReasons((prev) => ({ ...prev, [returnObject.id]: value }));
                ReturnStore_1.default.setProperty(returnObject.id, 'returnReason', value);
            } }),
        react_1.default.createElement("small", { className: "text-danger align-self-start znd-return-table-sub__sub-item__error__text" }, ReturnStore_1.default.getValidationError(returnObject.id, 'returnReason') ??
            ReturnStore_1.default.getValidationError(returnObject.id, 'returnReason')))) : (react_1.default.createElement(react_1.default.Fragment, null, (0, translation_1.t)('myassets.returns.table.select_return_reason', {
        returnReason: returnObject.returnReason,
    })))));
};
exports.default = (0, mobx_react_1.observer)(ReturnReasonObservableComponent);
